import React from 'react';
import { formatBillMoney } from './format';

/**
 * A money figure for a summary card: one line per currency present, each in its own label ("TT$300.00",
 * "US$50.00"), in a fixed order (by code) whatever order the server sent them. Never one figure claiming to
 * be all currencies (t09; invariant 5: unlike currencies are never treated as equal), so a card that has
 * no per-currency figures reads a plain zero rather than inventing a currency for a sum.
 *
 * The Accounts bill list's cards and the Payment vouchers cards read the same way, so they share this
 * rather than each carrying a copy (lane 5, V3d). `byCurrency` is the server's own grouping; `field` names
 * the figure to show from each currency's row.
 */
export function CurrencyLines({
  byCurrency,
  field,
}: {
  byCurrency?: Record<string, Partial<Record<string, number>>>;
  field: string;
}) {
  const currencies = Object.keys(byCurrency || {}).sort((a, b) => a.localeCompare(b));
  if (!currencies.length) return <>{formatBillMoney(0)}</>;
  return (
    <>
      {currencies.map((cur) => (
        <div key={cur}>{formatBillMoney((byCurrency as Record<string, Partial<Record<string, number>>>)[cur][field], cur)}</div>
      ))}
    </>
  );
}
